import { useSearchParams } from 'next/navigation';

const PRODUCT_LIST_RESET_KEY_EXCLUDED_PARAMS = new Set(['page']);

type SearchParamsEntries = Pick<URLSearchParams, 'entries'>;

export const getProductListResetKey = (searchParams: SearchParamsEntries) =>
  new URLSearchParams(
    Array.from(searchParams.entries()).filter(
      ([key]) => !PRODUCT_LIST_RESET_KEY_EXCLUDED_PARAMS.has(key),
    ),
  ).toString();

const useProductListResetKey = () => {
  const searchParams = useSearchParams();

  return getProductListResetKey(searchParams);
};

export default useProductListResetKey;
